import {
  Box,
  Button,
  Group,
  LoadingOverlay,
  Paper,
  Stack,
  Text,
  TextInput,
} from "@mantine/core";
import { useNavigate, useParams, useRouteLoaderData } from "react-router-dom";
import { useLanguage } from "../../../../stores/LanguageStore";
import { useEffect, useState } from "react";
import BackButton from "../../../../components/View/BackButton";
import { createOrg, editOrg } from "../../../../api/UserAPI";
import { notifications } from "@mantine/notifications";
import { getEmails } from "../../../../api/EmailAPI";
import { parseDate } from "../../../../functions/dates";
import { IconDeviceFloppy } from "@tabler/icons-react";
import CountrySelector from "../../../../components/Selectors/CountrySelector";

const OrgSettings = () => {
  const lang = useLanguage((s) => s.language);
  const { orgId } = useParams();
  const profile = useRouteLoaderData("organization");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData);

    setLoading(true);

    const main = orgId ? editOrg : createOrg;
    main({ id: parseInt(orgId), name: data.name })
      .then((response) => {
        notifications.show({
          message: orgId
            ? lang.organizations.row_highlight.updated
            : lang.organizations.row_highlight.created,
          color: "tertiary.8",
        });
        navigate(
          "/settings/organizations/none?highlight=" +
            (response?.data?.organization_id || profile?.id)
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getEmails();
  }, []);

  return (
    <Stack
      component={"form"}
      onSubmit={handleSubmit}
      pos={"relative"}
      gap={"lg"}
      mt={32}
    >
      <LoadingOverlay
        visible={loading}
        w={"100%"}
        h={"100%"}
        overlayProps={{
          blur: 2,
        }}
      />
      <Paper component={Group} p={"md"} gap={"xl"} px={"xl"}>
        <Text size="xl" fw={700}>
          {lang.settings.org_name}
        </Text>
        <TextInput
          name="name"
          defaultValue={profile?.name}
          required
          autoFocus
          size="lg"
          w={300}
        />

        {profile && (
          <Text ml={"auto"}>
            {lang.white_labels.created_on} {parseDate(profile.created_on)}
          </Text>
        )}
      </Paper>

      <Paper component={Stack} p={"md"} gap={"md"} px={"xl"}>
        <Text size="xl" fw={700}>
          {lang.settings.org_info}
        </Text>

        <Group w={"100%"} gap={"lg"}>
          <TextInput
            defaultValue={profile?.vat_number}
            name="website"
            placeholder="XXXXX"
            label={lang.settings.vat_label}
            w={"45%"}
            size="md"
          />
          <TextInput
            defaultValue={profile?.address}
            placeholder="30è rue du ..."
            name="address"
            label={lang.profile.address}
            w={"45%"}
            size="md"
          />
          <TextInput
            defaultValue={profile?.zip_code}
            label={lang.profile.postal_code}
            name="zip_code"
            placeholder="40556, ..."
            w={"45%"}
            size="md"
          />
          <TextInput
            defaultValue={profile?.city}
            label={lang.profile.city}
            name="city"
            placeholder="Paris, ..."
            w={"45%"}
            size="md"
          />
          <CountrySelector
            label={lang.profile.country}
            placeholder={lang.profile.country}
            name="country"
            defaultValue={profile?.country}
            w={"45%"}
          />
          <TextInput
            defaultValue={profile?.website}
            name="website"
            placeholder="Site web"
            label={lang.settings.website}
            type="url"
            w={"45%"}
            size="md"
          />
        </Group>
      </Paper>

      <Group
        justify="end"
        gap={"xl"}
        pos={"sticky"}
        bottom={0}
        p={"md"}
        bg={"#fff"}
        style={{ borderRadius: 12 }}
      >
        <BackButton size="md" />
        <Button
          type="submit"
          color="primary"
          size="md"
          leftSection={<IconDeviceFloppy />}
        >
          {profile ? lang.global.save : lang.organizations.create.button_label}
        </Button>
      </Group>
    </Stack>
  );
};

export default OrgSettings;
